import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Helmet from 'react-helmet';
import componentBase from '../../../../src/lib/component-base';
import { dateFormatString } from '../../../../src/lib/date-time-format';
import DataExport from './children/dataExport';
import NoDataExports from './children/NoDataExports';
import {
  getAllDataExportForUser,
  openOption,
  createDataExportEvent,
  getDataExportById,
  softDataExportDelete,
  removeDataExport,
  openDeleteExportModal,
  closeDeleteExportModal,
  setPollingStatus,
  handleDataEventRefresh,
  clearCurrentPollingExportId,
} from '../../redux/actions';
import {
  startSpinner,
  endSpinner,
} from '../../../Account/redux/actions';
import { handlePollingForCookie } from '../lib/helpers/handlePollingForCookie';
import reportException from '../../../../shared/lib/report-exception';
import pollForNewState from '../../../../shared/lib/poll-for-new-state';
import FSFlatButton from '../../../../src/components/lib/FSFlatButton';
import DataExportsPreviousSearchIconsWHITE from '../../../../static/images/data-export-icons/DataExports-PreviousSearch-Icons-WHITE.svg';
import FiveStepsBackground from '../../../../static/images/Step1-5-Banner-Background.png';
import FiveStepsText from '../../../../static/images/Step1-5-text.svg';
import TrashcanBLACK from '../../../../static/images/Trashcan-BLACK.svg';
import DataExportsHeader from '../shared/DataExportsHeader';
import IconHeader from '../../../../shared/components/IconHeader/IconHeader';
import convertToLocalTime from '../../../../src/helpers/dateHelpers';
import LargeGenericModal from '../../../../shared/components/LargeGenericModal/LargeGenericModal';
import RenderOnClient from '../../../../src/components/lib/RenderOnClient';
import {
  mapExportTypes,
  mapCategories,
  validStatusesToOpenOptionsMenu,
} from './constants';
import {
  noPollForStatuses,
  previousDataExportScreenStatuses,
} from '../../redux/data-constants';
import BannerAd from '../../../../shared/components/BannerAd/BannerAd';
import { DataExports as DataExportsAds } from '../ads';
import { openTab } from '../../../../src/utils/openTab';

const DEFAULT_TIMEOUT = 12;
const SESSION_KEY = 'DataExportsHome';

@connect(state => ({
  loading: state.DataExports.dataExportQuoteHistoryLoading,
  previousDataExports: state.DataExports.dataExportQuoteHistory,
  exportsOptionOpen: state.DataExports.exportsOptionOpen,
  downloadedCSVcontent: state.DataExports.downloadedCSVcontent,
  downloadingCSVError: state.DataExports.downloadingCSVError,
  canDeleteDataExport: state.DataExports.canDeleteDataExport,
  deletedDataExport: state.DataExports.deletedDataExport,
  exportToDeleteId: state.DataExports.exportToDeleteId,
  deleteExportModalOpen: state.DataExports.deleteExportModalOpen,
  dataExportEvent: state.DataExports.dataExportEvent,
  polling: state.DataExports.polling,
  shouldComponentUpdate: state.DataExports.shouldComponentUpdate,
  currentlyGeneratingExportId: state.DataExports.currentlyGeneratingExportId,
  user: state.Account.user,
}))

@componentBase('DataExports')
export default class DataExports extends React.Component {
  static propTypes = {
    dataExportPollStatuses: PropTypes.array,
    dataExportEvent: PropTypes.object,
    dispatch: PropTypes.func,
    exportsOptionOpen: PropTypes.number,
    loading: PropTypes.bool,
    location: PropTypes.object,
    previousDataExports: PropTypes.array,
    canDeleteDataExport: PropTypes.bool,
    deletedDataExport: PropTypes.number,
    exportToDeleteId: PropTypes.number,
    deleteExportModalOpen: PropTypes.bool,
    name: PropTypes.string,
    route: PropTypes.object,
    polling: PropTypes.bool,
    shouldComponentUpdate: PropTypes.bool,
    currentlyGeneratingExportId: PropTypes.number,
    user: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      // can only have 1 'options' open at a time (ones close together will overlap)
      exportsOptionsOpen: NaN,
      statusUpdateTimeout: DEFAULT_TIMEOUT,
      cookieName: '',
    };

    this.pollForRecentStatusChange = this.pollForRecentStatusChange.bind(this);
    this.killCookieUpdateTimer = this.killCookieUpdateTimer.bind(this);
    this.handlePollingForCookie = handlePollingForCookie.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.downloadAsCSV = this.downloadAsCSV.bind(this);
    this.statusUpdateTimer = null;
    this.cookieUpdateTimer = null;
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getAllDataExportForUser(this.pollForRecentStatusChange));
    setTimeout(this.markUniqueTabState, 1000);
  }

  componentWillReceiveProps(nextProps) {
    const {
      deletedDataExport,
      previousDataExports,
      dataExportEvent,
    } = nextProps;

    if (deletedDataExport) {
      this.removeDataExport(previousDataExports, deletedDataExport);
      this.props.dispatch(closeDeleteExportModal());
      this.props.dispatch(endSpinner());
    }
    if (dataExportEvent) {
      // clears dataExportEvent and gets current export statuses
      this.props.dispatch(handleDataEventRefresh());
    }
  }

  componentWillUnmount() {
    const home = this.getContainerElementRef();
    if (home) {
      // this listener handles the case for back and forward button presses
      home.removeEventListener('beforeunload', this.resetFrozenStateMarker);
    }
    /*
      but we also need to reset for any other page leave
      except duplicate tab so we get to call it here as well
    */
    this.resetFrozenStateMarker();

    if (!isNaN(this.props.exportsOptionOpen)) {
      // if an option is still open, close it
      this.promiseDispatch(this.context.store)(openOption(NaN));
    }
    this.killCookieUpdateTimer();
    this.killStatusUpdateTimer();
    // just in case spinner is still going for some reason...
    this.props.dispatch(endSpinner());
  }

  getContainerElementRef = () => {
    if (typeof document !== 'undefined') {
      const dataExportsHome = document.querySelector('.data-exports-container');
      if (dataExportsHome && dataExportsHome.nodeType) {
        return dataExportsHome;
      }
    }
    return null;
  }

  getValidExport = (dataExport) => {
    const defaultValue = '--';
    const {
      status,
      created_at: createdAt,
      cost,
      download,
      type,
    } = dataExport;
    const dateCreated = createdAt ?
      convertToLocalTime(createdAt).format(dateFormatString(this.props.user)) :
      defaultValue;
    const exportType = type ? `${mapCategories(type)} ${mapExportTypes(type)}` : '';

    return {
      cost: cost || defaultValue,
      dateCreated,
      download: download || defaultValue,
      exportType,
      status: status || defaultValue,
    };
  }

  setTimerRef = (newTimer) => {
    this.statusUpdateTimer = newTimer();
  }

  setCookieTimerRef = (newTimer) => {
    this.cookieUpdateTimer = newTimer();
  }

  setFrozenStateMarker = () => {
    const { store } = this.context;
    // this page in a loaded state will have a session key set to true
    const markAsLoadedState = { preLoadedTab: true };
    this.freezeState(store, markAsLoadedState, SESSION_KEY);
  }

  resetFrozenStateMarker = () => {
    const { store } = this.context;
    // when the page enters it should have no session key at all
    this.freezeState(store, null, SESSION_KEY);
  }

  killStatusUpdateTimer = () => {
    this.props.dispatch(clearCurrentPollingExportId());

    if (this.props.polling) {
      this.props.dispatch(setPollingStatus(false));
    }
    if (this.statusUpdateTimer) {
      clearTimeout(this.statusUpdateTimer);
      this.statusUpdateTimer = null;
    }
  }

  killCookieUpdateTimer = () => {
    if (this.props.polling) {
      this.props.dispatch(setPollingStatus(false));
    }
    if (this.cookieUpdateTimer) {
      clearTimeout(this.cookieUpdateTimer);
      this.cookieUpdateTimer = null;
    }
    // cleanup by deleting cookie that corresponds to the download
    this.deleteCookie();
    // done, so stop the spinner
    this.props.dispatch(endSpinner());
  }

  createDataExportEvent = (dataExportEventType, id) => {
    this.props.dispatch(createDataExportEvent(dataExportEventType, id));
  }

  markUniqueTabState = () => {
    // componentWillUnmount does not seem to be handling this on back button press
    const home = this.getContainerElementRef();
    if (home) {
      home.addEventListener('beforeunload', this.resetFrozenStateMarker);
    }

    // check if we have the correct marker in the session and handle state if the tab is a duplicate
    this.handleStateMarker();

    // set a new marker in the session
    this.setFrozenStateMarker();
  }

  dataExportError = status => status && status.toLowerCase().includes('failed');

  deleteCookie = (path) => {
    const namePart = `${this.state.cookieName || ''}=""`;
    const pathPart = `path=${path || '/'}`;
    const expiration = 'expires=Thu, 01 Jan 1970 00:00:01 GMT';// set cookie to being expired a long time ago;
    const newCookie = [namePart, pathPart, expiration].join(';');
    try {
      document.cookie = newCookie;
    } catch (e) {
      this.logErrors('could not delete cookie', e);
    }
  }

  downloadAsCSV = (id) => {
    // just need id of a data xport
    this.props.dispatch(startSpinner());
    const cookieName = new Date().getTime();
    this.setState({
      cookieName, // ex: 1493140063584
    });

    const tabName = 'data_export.csv';
    try {
      const tabUrl = `${window.location && window.location.origin}/v2/api/data-exports/download?id=${id}&cookie=${cookieName}&location=home`;

      // TODO:
      // /v2 appended for need to remove in the future when /v2 is no longer required.
      //

      const tab = window.open(tabUrl, tabName);
      this.props.dispatch(setPollingStatus(true));
      this.handlePollingForCookie(cookieName, id, tab);
    } catch (e) {
      this.logErrors('unable to open new tab to download csv', e);
    }
  }

  handleContainerClick = (e) => {
    e.preventDefault();
    if (!isNaN(this.props.exportsOptionOpen)) {
      // if an option is open and a click is caught by container, close option
      this.promiseDispatch(this.context.store)(openOption(NaN));
    }
  }

  handleDelete = () => {
    if (this.props.canDeleteDataExport) {
      this.props.dispatch(startSpinner());
      this.props.dispatch(softDataExportDelete(this.props.exportToDeleteId));
    }
  }

  handleNewExportClick = (e) => {
    e.preventDefault();
    this.props.dispatch(push('/data-exports/new'));
  }

  logErrors = (errorString = '', errorObject) => (errorString ?
    reportException({ message: errorString }, this.props.location && this.props.location.pathname) :
    reportException(errorObject, this.props.location && this.props.location.pathname));

  navigateTo = (url) => {
    this.props.dispatch(push(url));
  }

  openDeleteExportModal = (id) => {
    this.props.dispatch(openDeleteExportModal(id));
  }

  closeDeleteExportModal = () => {
    this.props.dispatch(closeDeleteExportModal());
  }

  showExportsView = () => (!this.props.loading || this.props.polling) &&
      (this.props.previousDataExports &&
      this.props.previousDataExports.length);

  showNoExportsView = () => (
    !this.props.loading &&
    !this.props.polling &&
      (!this.props.previousDataExports ||
      !this.props.previousDataExports.length)
  );

  openOption = (index) => {
    const { store } = this.context;
    // close all the options (ensures only one option is open at a time)
    this.promiseDispatch(store)(openOption(NaN))
      .then(() => {
      // open the correct one
        this.promiseDispatch(store)(openOption(index));
      });
  }

  removeDataExport = (prevExports, id) => {
    this.props.dispatch(removeDataExport(prevExports, id));
  }

  handleStateMarker = () => {
    if (this.isDuplicateTabLoading()) {
      this.setFrozenStateMarker();
      this.props.dispatch(getAllDataExportForUser());
    }
  }

  isDuplicateTabLoading = () => {
    const frozen = this.frozenState(this.context.store, SESSION_KEY);
    const staleData = frozen && frozen.preLoadedTab;

    return (typeof window !== 'undefined' && window.performance) && // if there is no window then chrome's duplicate tab 'feature' will not be an issue anyway
      (staleData && performance.navigation.type !== 1);
    // do not check for a marker on a simple page refresh
  }

  handleStatusUpdateTimeout = () => this.state.statusUpdateTimeout < 1;

  handlePollingIdMismatch = (data) => {
    const {
      id,
      oldId,
    } = data;
    if (id !== oldId) {
      const ex = new Error(`hub callback returned an unexpected id polling for data exports expected: ${oldId} got ${id}`);
      this.exception(ex, 'Data Exports Home Container');
      return true;
    }
    return false;
  }

  handlePollingGotNewStatus = (data) => {
    const {
      oldStatus,
      status: newStatus,
    } = data;
    if (oldStatus === 'count_succeeded' &&
          newStatus === oldStatus) {
      /*
        sometimes we get here even before the 'generating'
        status does so we have to begin by polling for that.
        but we also have to cut it off after a few tries because
        there are a lot of 'count_succeeded's that could never change.
        TLDR: don't poll forever
      */
      this.setState({
        statusUpdateTimeout: (this.state.statusUpdateTimeout - 3),
      });
      return false;
    }
    if (previousDataExportScreenStatuses[newStatus] &&
        !noPollForStatuses[newStatus] &&
         oldStatus === 'count_succeeded') {
      // update the ui *and* keep polling if we started here without an initial 'generating' status
      this.props.dispatch(getAllDataExportForUser());
      return false;
    }
    if (newStatus && noPollForStatuses[newStatus]) {
      // stop polling, force an update in redux, and =>
      this.props.dispatch(getAllDataExportForUser());
      return true;
    }
    return false;
  }

  pollForRecentStatusChange = (pollingExport) => {
    this.props.dispatch(setPollingStatus(true));
    const {
      id,
      status,
    } = pollingExport;
    const pollingExitCallbacks = [
      this.handleStatusUpdateTimeout,
      data => this.handlePollingIdMismatch({ ...data, oldId: id }),
      data => this.handlePollingGotNewStatus({ ...data, oldStatus: status })];
    const pollingArgs = {
      initialPromise: () => this.props.dispatch(getDataExportById(id)),
      killTimer: this.killStatusUpdateTimer,
      exitCallbacks: pollingExitCallbacks,
      interval: 3000,
      setTimerRef: this.setTimerRef,
      displayName: 'DataExports',
    };
    pollForNewState(pollingArgs);
  }

  validStatusForOptionsMenu = status => status in validStatusesToOpenOptionsMenu;

  renderDataExports = () => {
    const { previousDataExports } = this.props;
    const dataExports = previousDataExports || [];
    // the row labels for data exports
    const dataExportColHeaders = [(
      <div className='row col-title' key={-1}>
        <div className='date-exported col-xs-2'>Date Created</div>
        <div className='export-type col-xs-3 col-sm-4'>Export Type</div>
        <div className='cost col-xs-3 col-sm-2'>Cost</div>
        <div className='status col-xs-3'>Status</div>
        <div className='options col-xs-1'>Options</div>
      </div>
    )];
    // end the row labels for data exports

    if (dataExports && dataExports.length) {
      const dataExportRows = dataExports.map((dataExport, i) => {
        // maybe need to do some manipulation of data...
        const {
          dateCreated, exportType, cost, status, download,
        } = this.getValidExport(dataExport);
        const { id, braintreeId } = dataExport;
        return (
          <DataExport
            cost={cost}
            dateCreated={dateCreated}
            download={download}
            exportType={exportType}
            error={this.dataExportError(status)}
            status={status}
            key={id}
            index={i}
            id={id}
            exportsOptionsOpen={this.props.exportsOptionOpen}
            openOption={this.openOption}
            openTab={openTab}
            downloadAsCSV={this.downloadAsCSV}
            braintreeId={braintreeId}
            navigateTo={this.navigateTo}
            openDeleteExportModal={this.openDeleteExportModal}
            optionsCanOpen={this.validStatusForOptionsMenu(status)}
          />
        );
      });

      dataExportColHeaders.push(dataExportRows);
    } else {
      // no data exports to show
      const noExports = (
        <div className='row exports-list' key={0}>
          You currently do not have any saved exports. Click New Export to create one.
        </div>
      );
      dataExportColHeaders.push(noExports);
    }
    return dataExportColHeaders;
  }

  renderLargeGenericModalBody = () => (
    <div className='export-delete-modal-body'>
      <p className='export-delete-modal-text'>
        You are about to delete this data export. Are you sure?
      </p>
    </div>
  )

  render() {
    const subscriptionActive = this.props.user && this.props.user.subscriptionActive;

    const adUnits = {
      mobileAd: DataExportsAds.topMobile,
      desktopAd: DataExportsAds.top,
    };

    const bannerAd = (
      <BannerAd
        topAd
        {...adUnits}
        subscriptionActive={subscriptionActive}
        style={{ marginBottom: '-10px' }}
      />
    );
    if (this.showNoExportsView()) {
      // no data exports to display and not seen marketing to get user to want to export data yet
      return (
        <div>
          { bannerAd }
          <Helmet title='Data Exports' />
          <NoDataExports />
        </div>
      );
    }
    if (this.showExportsView()) {
      return (
        <div
          className='data-exports-container'
          onClick={this.handleContainerClick}
          ref='dataExportsHome'
        >
          <Helmet title='Data Exports' />
          { bannerAd }
          <LargeGenericModal
            modalOpen={this.props.deleteExportModalOpen}
            closeModal={this.closeDeleteExportModal}
            title='Delete This Data Export'
            image={TrashcanBLACK}
            actionTitle='YES, DELETE THIS EXPORT'
            selectAction={this.handleDelete}
            disableButtons={!this.props.canDeleteDataExport}
            secondaryActionBackgroundColor='transparent'
            secondaryActionHoverColor='#c6c6c6'
            body={this.renderLargeGenericModalBody()}
          />
          <DataExportsHeader
            primaryText='Data Exports'
          />
          <div className='row guide-row'>
            <section className='how-this-works col-xs-12 col-md-7'>
              <div className='content five-export-steps'>
                <img src={FiveStepsBackground} alt='five-export-steps' />
                <img src={FiveStepsText} className='steps-text' alt='five-export-steps' />
              </div>
            </section>
            <section className='new-data-export col-xs-12 col-md-5'>
              <div className='content'>
                <div className='text-and-button'>
                  <p>Ready to Generate a New Data Export?</p>
                  <div className='button-holder'>
                    <FSFlatButton
                      label='NEW EXPORT'
                      onClick={this.handleNewExportClick}
                      style={{ width: '250px' }}
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
          <section className='data-exports'>
            <div className='text-and-icon'>
              <IconHeader icon={DataExportsPreviousSearchIconsWHITE} title='Previous Data Exports' />
            </div>
            <div className='data-export-list'>
              <div className='data-export-list-extension left' onClick={e => this.handleContainerClick(e)} />
              <div className='data-export-list-extension right' onClick={e => this.handleContainerClick(e)} />
              <RenderOnClient>
                <div>
                  {this.renderDataExports()}
                  <div className={isNaN(this.props.exportsOptionOpen) ? '' : 'data-export-list-extension bottom'} onClick={e => this.handleContainerClick(e)} />
                </div>
              </RenderOnClient>
            </div>
          </section>
        </div>
      );
    }
    return (<div />);
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/home/DataExportsHomeContainer.js